<template>
  <div>
    <form @submit.prevent="handleFormSubmit" class="form">
      <register-title class="form__title">{{
        $t("taxpayer info")
      }}</register-title>
      <div class="select-container">
        <label class="label">{{ $t("taxpayer info") }}</label>
        <exp-select
          :options="registrationCountryList()"
          v-model="form.tax_residency"
          :title="$t('choose country')"
        ></exp-select>
      </div>
      <!--------------------------------------------------------   BIK SERIES   ----->
      <register-input
        v-model="form.bic"
        componentID="bik"
        inputType="text"
        :label="$t('bank details')"
        :inputPlaceholder="$t('bank details')"
        :isRequired="true"
        class="form__input"
      />
      <!--------------------------------------------------------   LEI SERIES   ----->
      <register-input
        v-model="form.lei"
        componentID="lei"
        inputType="text"
        :label="$t('lei')"
        :inputPlaceholder="$t('lei')"
        :isRequired="false"
        class="form__input"
      />
      <!--------------------------------------------------------  giin  SERIES   ----->
      <register-input
        v-model="form.giin"
        componentID="giin"
        inputType="text"
        :label="$t('giin')"
        :inputPlaceholder="$t('giin')"
        :isRequired="false"
        class="form__input"
      />
      <br />
      <div class="row bottom-xs" v-if="form.tax_residency != 92">
        <div class="col-xs-12 col-sm-6">
          <register-input
            v-model="form.foreign_tax_register_number"
            componentID="operation_register_number"
            inputType="text"
            :inputPlaceholder="$t('register number placeholder')"
            :label="$t('register number')"
            :isRequired="false"
            class="form__input"
          />
        </div>
        <div class="col-xs-12 col-sm-6">
          <register-input
            v-model="form.foreign_tax_number"
            componentID="giin"
            inputType="text"
            :label="$t('taxpayer number')"
            :inputPlaceholder="$t('taxpayer number')"
            :isRequired="false"
            class="form__input"
          />
        </div>
        <!--        <div-->
        <!--          class="col-xs-12"-->
        <!--          @click="addCountryOperation"-->
        <!--          v-if="-->
        <!--            operation_country.foreign_tax_register_number.length > 0 &&-->
        <!--              operation_country.foreign_tax_number.length > 0-->
        <!--          "-->
        <!--        >-->
        <!--          <div class="pane-list-add" style="float: left !important;">-->
        <!--            <p>Добавить <b>сведения</b></p>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <!--      <hr class="horizontal-line" />-->
      <file-input
        :mini="true"
        :is_uploaded="form_files.legal_registration_foreign"
        v-model="form_files.legal_registration_foreign"
        @attached="
          saveFile(
            form_files.legal_registration_foreign,
            'legal_registration_foreign'
          )
        "
        class="form__input-container"
        componentID="doc_2"
      >
        {{ $t("non-residents register certificate") }}
      </file-input>
      <button class="button filled form__button">{{ $t("confirm") }}</button>
    </form>
  </div>
</template>

<script>
import regFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";
export default {
  props: ["user_profile"],
  name: "MainRegForm",
  data() {
    return {
      old_form: {},
      operation_country: {
        register_number: "",
        tax_number: ""
      },
      form_files: {
        legal_registration_foreign: null
      },
      form: {
        tax_residency: null,
        bic: null,
        lei: null,
        giin: null,
        foreign_tax_register_number: null,
        foreign_tax_number: null
        // operation_countries: []
      },
      form_dates: []
    };
  },
  mixins: [regFormMixin],
  watch: {
    user_profile: function(value) {
      this.fetchForm();
    }
  },
  methods: {
    addCountryOperation() {
      this.form.operation_countries.push(
        JSON.parse(JSON.stringify(this.operation_country))
      );
      this.operation_country.register_number = "";
      this.operation_country.tax_number = "";
    },
    deleteCountryOperation(index) {
      this.form.operation_countries.splice(index, 1);
    },
    formatDocNumber() {
      this.form.document_number = this.form.document_number.replace(/\D/g, "");
      this.form.document_number = this.form.document_number.substr(0, 9);
    },
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        Object.entries(this.user_profile.userProfile).map(obj => {
          if (obj[0] in this.form) {
            this.form[obj[0]] = obj[1];
          }
        });
        Object.entries(this.form_files).map(obj => {
          let find_file = this.user_profile.userUploadedDocuments.find(
            file => file.type === obj[0]
          );
          this.form_files[obj[0]] = (find_file ? true : null) || null;
        });
        this.form_dates.forEach(date => {
          this.form[date] = this.dateFormat(this.form[date]);
        });
        // console.log(this.isKazDoc(this.form.document_type));
        this.old_form = JSON.parse(JSON.stringify(this.form));
      } catch (e) {
        // ERROR HANDLER
      }
    },
    isFilesAdded() {
      return this.form_files.legal_registration_foreign;
    },
    nextStep() {
      this.$router.push({ name: "legal-owners" });
    },
    saveData() {
      let url = `user/profile`;
      const form = JSON.parse(JSON.stringify(this.form));
      this.form_dates.forEach(date => {
        form[date] = this.dateReFormat(form[date]);
      });
      FhsAxios.post(url, form).then(res => {
        if (res.data.status) {
          this.$toasted.success(this.$t("data saved"));
          this.nextStep();
          return;
        }
        this.$toasted.error(this.$t("error"));
        this.$emit("loading-status", false);
      });
    },
    handleFormSubmit() {
      if (this.isFilesAdded()) {
        this.saveData();
      } else {
        this.$toasted.clear();
        this.$toasted.show(this.$t("attach files"));
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
